import "./inventory.css";
import React, { useState } from "react";
import momentTZ from 'moment-timezone';


export default function RewardRedemptionSortableTable({ data }) {
    const [sortConfig, setSortConfig] = useState({ key: '', direction: "asc" });

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...data].sort((a, b) => {
        if (!sortConfig.key) return 0;
        const valA = a[sortConfig.key];
        const valB = b[sortConfig.key];
        if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
        if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return (<svg width="10" height="10" viewBox="0 0 10 10">
            </svg>);
        }
        return sortConfig.direction === "asc" ? (
            <svg width="10" height="10" viewBox="0 0 10 10">
                <path d="M0 6 L5 1 L10 6 Z" fill="#999" />
            </svg>
        ) : (
            <svg width="10" height="10" viewBox="0 0 10 10">
                <path d="M0 4 L5 9 L10 4 Z" fill="#999" />
            </svg>
        );
    };

    return (
        <table className="styled-table">
            <thead>
                <tr>
                    <th onClick={() => handleSort("user_id")}>
                        BC/SAP No {getSortIcon("user_id")}
                    </th>
                    <th onClick={() => handleSort("name")}>
                        Name {getSortIcon("name")}
                    </th>
                    <th onClick={() => handleSort("dept_desc")}>
                        Department {getSortIcon("dept_desc")}
                    </th>
                    <th onClick={() => handleSort("redeemed_count")}>
                        Redeem Quantity {getSortIcon("redeemed_count")}
                    </th>
                    <th onClick={() => handleSort("point_cost")}>
                        Points Deducted {getSortIcon("point_cost")}
                    </th>
                    <th onClick={() => handleSort("created_on")}>
                        Claimed On {getSortIcon("created_on")}
                    </th>
                    <th onClick={() => handleSort("redeemed_on")}>
                        Redeemed On {getSortIcon("redeemed_on")}
                    </th>
                </tr>
            </thead>
            <tbody>
                {sortedData.map((row, index) => (
                    <tr key={index}>
                        <td>{row.user_id || '-'}</td>
                        <td>{row.name || '-'}</td>
                        <td>{row.dept_desc || '-'}</td>
                        <td>{row.redeemed_count}</td>
                        <td>{row.point_cost}</td>
                        <td>{row.created_on && row.created_on != '-' ? momentTZ.tz(`${row.created_on}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().format('DD MMM YYYY, hh:mm A') : "-"}</td>
                        <td>{row.redeemed_on && row.redeemed_on != '-' ? momentTZ.tz(`${row.redeemed_on}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().format('DD MMM YYYY, hh:mm A') : "-"}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}